import { styled, keyframes, css } from 'styled-components'

import { IoClose } from "react-icons/io5";

const fadeInDown = keyframes`
    from{
        opacity: 0;
        transform: translateY( -20px );
    }
    to{
        opacity: 1;
        transform: translateY( 0 );
    }
`

const sizeStyles = {
    sm: css`width: 400px;`,
    md: css`width: 550px;`,
    lg: css`width: 900px;`,
    xl: css`width: 1200px;`
};

const Container = styled.div`
    ${({ size }) => sizeStyles[size] || sizeStyles["md"]};
    max-width: 95%;
    min-width: 0;
    max-height: 90dvh;
    height: min(90dvh, max-content);
    border-radius: 12px;
    margin: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: ${ fadeInDown } .3s ease-out;
    position: relative;
`
const Header = styled.div`
    width: 100%;
    height: 40px;
    background-color: #263B4B;
    display: flex;
    flex-shrink: 0;
    svg{
        width: 30px;
        height: 30px;
        margin: auto 10px auto auto;
        color:rgb(190, 4, 4);
        cursor: pointer;
        transition: .3s;
        &:hover{
            scale: 1.3;
        }
    }
`
const Body = styled.div`
    width: 100%;
    min-width: 0;
    flex: 1;
    min-height: 0;
    background-color: #FFFFFF;
    /* Overlay usa color: white; herança tornava texto invisível no fundo branco */
    color: #1f2937;
    padding: ${({ noPadding }) => noPadding ? '0' : '20px' };
    box-sizing: border-box;
    overflow-x: ${({ blockOverflow }) => (blockOverflow ? "visible" : "hidden")};
    overflow-y: ${({ blockOverflow }) => (blockOverflow ? "visible" : "auto")};

    table,
    th,
    td {
        color: #1f2937;
    }

    strong {
        color: #111827;
    }

    input:not([type="submit"]),
    select,
    textarea {
        color: #1f2937;
        background-color: #ffffff;
        -webkit-text-fill-color: #1f2937;
    }
`

const Modal = ({ children, header, close, size = "md", blockOverflow = false, noPadding = false }) => {

    return (
        <Container size={ size } onClick={(e) => e.stopPropagation()} >
            {
                header &&
                <Header>
                    <IoClose onClick={ close ?? (() => {}) } />
                </Header>
            }
            <Body blockOverflow={ blockOverflow } noPadding={ noPadding }>{ children }</Body>
        </Container>
    )

}

export default Modal;